import { createSlice } from '@reduxjs/toolkit';
import { StatusLoading } from 'common/constants';

import { IState, STATE } from '../types/state';

import setEventsLoadingStatus from './setEventsLoadingStatus';
import setEvents from './setEvents';
import resetEvents from './resetEvents';
import resetActiveEvent from './resetActiveEvent';
import setSpecialEventLoadingStatus from './setSpecialEventLoadingStatus';
import setActiveSpecialEventData from './setActiveSpecialEventData';
import setScrollToSelectedEventId from './setScrollToSelectedEventId';
import setSpecialEventForAuthorizedUsers from './setSpecialEventForAuthorizedUsers';

const initialState: IState = {
  specialEvents: {
    isLoading: StatusLoading.Default,
    data: [],
    scrollToSelectedEvent: '',
  },
  activeSpecialEvent: {
    isLoading: StatusLoading.Default,
    data: null,
    onlyForAuthorizedUsers: false,
  },
};

const slice = createSlice({
  name: STATE,
  initialState,
  reducers: {
    setEventsLoadingStatus,
    setEvents,
    resetEvents,

    setSpecialEventLoadingStatus,
    setActiveSpecialEventData,
    resetActiveEvent,

    setScrollToSelectedEventId,
    setSpecialEventForAuthorizedUsers,
  },
});

export default slice;
